
import { Component, Inject, OnInit, Renderer2 } from '@angular/core';
import { JeeSession1Service } from '../jee-session1.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { NgDialogAnimationService } from 'ng-dialog-animation';
import { ColDef } from 'ag-grid-community';

@Component({
  selector: 'app-neet-hlt-not-applied',
  templateUrl: './neet-hlt-not-applied.component.html',
  styleUrls: ['./neet-hlt-not-applied.component.scss']
})
export class NeetHltNotAppliedComponent implements OnInit {
  searchCriteria: string;
  options: any;
  admNo: string;
  params: any;
  dialog: any;
  className: any;
  constructor(private jeemains: JeeSession1Service, @Inject(MAT_DIALOG_DATA) public data: any, dialog: NgDialogAnimationService, public dialogRef: MatDialogRef<NeetHltNotAppliedComponent>, private renderer: Renderer2) { }
  ngOnInit(): void {
   this.getNeetNotAppliedData();
  }

  campusId: any
  programName: any

  rowData1: any[];
  formatHeader(key: string): string {
    return key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
  }

  columnDefs1: ColDef[] = [
      {
        headerName: 'Admission No',
        field: 'admNo',
        flex: 1
      },
      {
        headerName: 'Student Name',
        field: 'name',
        flex: 2,
        cellRenderer: (params: {
          data: any;
          context: any; value: string;
        }) => {
          const container = document.createElement('div');
          container.style.display = 'flex';
          container.style.alignItems = 'center';
          container.style.justifyContent = 'space-between';
  
          // Student Name Text
          const nameSpan = document.createElement('span');
          nameSpan.innerText = params.value || '';
          nameSpan.style.marginRight = '6px';
  
          // + Icon
          const icon = document.createElement('img');
          icon.src = 'assets/image/addIcon.svg';
          icon.style.width = '14px';
          icon.style.cursor = 'pointer';
          icon.title = 'Add';
  
          icon.onclick = () => {
             console.log('Clicked row data:', params.data);
              this.dialogRef.close(params.data);
          };
          container.appendChild(nameSpan);
          container.appendChild(icon);
          return container;
        }
  
      }
    ];

    defaultColDef = {
      cellStyle: {
        fontFamily: 'Poppins',
        fontWeight: 400, textAlign: 'left'
      },
      headerStyle: {
        fontWeight: 'bold',
        background: '#0564B1',
        color: 'white'
      },
      resizable: true
    };
  getNeetNotAppliedData(): void {
    this.programName = this.data.program;
    console.log(this.programName);
    this.jeemains.getNotAppliedNeetStudents(this.programName).subscribe((data) => {
      console.log(data);
      this.rowData1 = data;
       if (data && data.length > 0) {
      this.className = data[0].className;
    }
    });
  }
onClose(): void {
    this.dialogRef.close();
    setTimeout(() => {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 200);
  }

  search(): void {
    if (this.searchCriteria && this.searchCriteria.length > 6) {
      this.jeemains.getNeetAdmNo(this.params.data.admNo).subscribe((res: any) => {
        this.options = res; // assuming res is a list of strings or student objects
      });
    }
  }  

}
